import { EventCard, FormattedEvent } from '@eventbrite/event-renderer';
import React from 'react';
import styles from './EventCardContainer.module.scss';

export const POINTS_OF_INTEREST_AFF_CODE = 'ebdssbpointsofinterest';

const utmOptions = {
    'utm-campaign': 'social',
    'utm-content': 'attendeeshare',
    'utm-medium': 'discovery',
    'utm-term': '',
    'utm-source': '',
    'utm-share-source': 'things-to-do',
};

export interface EventCardContainerProps {
    isAuthenticated: boolean;
    eventData: FormattedEvent;
    currencyFormat: string;
    isMobile: boolean;
    facebook_locale?: string;
    serverUrl: string;
}

export const EventCardContainer = (props: EventCardContainerProps) => {
    const { eventData, isAuthenticated, currencyFormat, isMobile } = props;

    return (
        // added a classname to select from the bentoCarousel component.
        <div className={`${styles.eventCard} eventCard--bento`}>
            <EventCard
                heapLocationString="PointOfInterest - EventCard"
                isAuthenticated={isAuthenticated}
                eventData={eventData}
                currencyFormat={currencyFormat}
                shouldConvertToUserTimezone={true}
                type={'grid'}
                isLazyImage={true}
                affCode={POINTS_OF_INTEREST_AFF_CODE}
                shouldShowIcons={true}
                isTargetBlank={true}
                shareOptions={{
                    eventId: eventData.id,
                    eventName: eventData.name,
                    eventUrl: eventData.url,
                    affCode: POINTS_OF_INTEREST_AFF_CODE,
                    utmOptions,
                    isMobile: isMobile,
                    serverUrl: '',
                    twitterHandle: 'Eventbrite',
                    facebookOptions: {
                        appId: '28218816837',
                        version: 'v2.8',
                        locale: 'en_US',
                    },
                }}
            />
        </div>
    );
};
